import Radii from 'app/assets/jsons/Radius.json';

export function GetRadii() {
  const data = Radii.radii;
  return data;
}
